import config from 'src/shared/config';
import axios from 'src/shared/utils/axios';
import { toLocalDateTimeStr } from 'src/shared/utils/localDateTime';
import { ApprovalDetailDto, ApprovalDto } from './approvalApi';
const FXM_API_ENABLED = config.servers.fxm.enabled;
const FXM_API_URL = config.servers.fxm.url;
export interface ScanExemptApprovalDto extends ApprovalDto {
  startDate: number; // 요청 시작 시간
  endDate: number; // 요청 종료 시간
  approvalNo: string;
  scanExemptStatus: string;
}
export type ScanExemptApprovalReqDto = Omit<
  ScanExemptApprovalDto,
  'approvalNo' | 'scanExemptStatus'
>;
export interface ScanExemptApprovalServerReqDto extends ApprovalDto {
  startDate: number; // 요청 시작 시간
  endDate: number; // 요청 종료 시간
}
export const convertScanExemptApprovalReqDtoToServerReq = (
  reqDto: ScanExemptApprovalReqDto
): ScanExemptApprovalServerReqDto => {
  return {
    code: reqDto.code,
    approvalStep: reqDto.approvalStep,
    currentStep: reqDto.currentStep,
    approvalType: reqDto.approvalType,
    status: reqDto.status,
    approvalMethod: reqDto.approvalMethod,
    remark: reqDto.remark,
    approvers: reqDto.approvers,
    startDate: reqDto.startDate,
    endDate: reqDto.endDate,
  };
};
export interface ScanExemptApprovalDetailDto extends ApprovalDetailDto {
  startDate: number;
  endDate: number;
  scanExemptStatus: string;
}
export interface ScanExemptApprovalDetailEntity extends ScanExemptApprovalDetailDto {
  startDateStr: string;
  endDateStr: string;
  applyDateStr: string;
  updatedTsStr: string;
}
export const toScanExemptApprovalDetailDtoToEntity = (
  dto: ScanExemptApprovalDetailDto
): ScanExemptApprovalDetailEntity => {
  return {
    ...dto,
    startDateStr: dto.startDate > 0 ? toLocalDateTimeStr(dto.startDate) : '',
    endDateStr: dto.endDate > 0 ? toLocalDateTimeStr(dto.endDate) : '',
    applyDateStr: dto.applyDate > 0 ? toLocalDateTimeStr(dto.applyDate) : '',
    updatedTsStr: dto.updatedTs > 0 ? toLocalDateTimeStr(dto.updatedTs) : '',
    progressApprovers: dto.progressApprovers === null ? [] : dto.progressApprovers,
    completeApprovers: dto.completeApprovers === null ? [] : dto.completeApprovers,
  };
};
interface ScanExemptApprovalApi {
  find(code: string): Promise<ScanExemptApprovalDetailEntity>;
  apply(reqDto: ScanExemptApprovalReqDto): Promise<ScanExemptApprovalDto>;
  cancel(approvalNo: string): Promise<boolean>;
  withdraw(approvalNo: string): Promise<boolean>;
}
class ScanExemptApprovalServerApi implements ScanExemptApprovalApi {
  async find(code: string): Promise<ScanExemptApprovalDetailEntity> {
    const resp = await axios.get<ScanExemptApprovalDetailDto>(
      `${FXM_API_URL}/api/scanexempt/find/${code}`
    );
    return toScanExemptApprovalDetailDtoToEntity(resp.data);
  }
  async apply(reqDto: ScanExemptApprovalReqDto): Promise<ScanExemptApprovalDto> {
    const serverReqDto: ScanExemptApprovalServerReqDto =
      convertScanExemptApprovalReqDtoToServerReq(reqDto);
    const resp = await axios.post<ScanExemptApprovalDto>(
      `${FXM_API_URL}/api/scanexempt/apply`,
      serverReqDto
    );
    return resp.data;
  }
  async cancel(approvalNo: string): Promise<boolean> {
    const resp = await axios.get<ScanExemptApprovalDetailDto>(
      `${FXM_API_URL}/api/scanexempt/cancel/${approvalNo}`
    );
    if ([400, 500].includes(resp.status)) {
      return false;
    }
    return true;
  }
  async withdraw(approvalNo: string): Promise<boolean> {
    const resp = await axios.get<ScanExemptApprovalDetailDto>(
      `${FXM_API_URL}/api/scanexempt/withdraw/${approvalNo}`
    );
    if ([400, 500].includes(resp.status)) {
      return false;
    }
    return true;
  }
}
const scanExemptApprovalApi = new ScanExemptApprovalServerApi();
export default scanExemptApprovalApi;
